import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Components
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import Constants from "../../../common/SupplierConstants";
import Constant from "../../../common/Constants";
import { SearchField } from "../../../Components/formElements/SearchField";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { currencyFormat, formatDateTime } from "../../../common/Validations";

// import UploadPurchaseOrder from "./UploadPurchaseModal";
import CommonFilterCustomerV2 from "../../customer_app/Customer_V2/Common/CommonFilterCustomerV2";
import UploadModal from "../../customer_app/Customer_V2/Common/UploadModal";
import UploadDataViewModal from "../../customer_app/Customer_V2/Common/UploadDataViewModal";
import ReverseTimer from "../../../Components/TableReverseTimer/ReverseTimer";
import { useReactToPrint } from "react-to-print";
import TendorPrint from "./TendorPrint";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import {
  getTenderList,
  tenderNr,
} from "../../../redux/feature/supplier_app/purchasingSlice";

const PublicTenderList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Customer");
  localStorage.setItem("submenu", "Purchase List");

  let tenderData = useSelector((state) => state?.purchasing?.tender);

  let tenderTable = useSelector(
    (state) => state?.purchasing?.tender.pagination
  ); // User Details from Store

  const [isCardVisible1, setCardVisible1] = useState(true);
  // eslint-disable-next-line
  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [showUploadModal, setShowUploadModal] = useState(false);

  const [parsedData, setParsedData] = useState([]);
  const [showDataModal, setShowDataModal] = useState(false);

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  // eslint-disable-next-line
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const handleUploadComplete = (data) => {
    setParsedData(data); // Store Excel data
    setShowDataModal(true); // Show the preview modal
  };

  const contentRef = useRef(null);
  const [getLoadingAdvice, setLoadingAdvice] = useState([]);
  // useReactToPrint declared at top level
  const handlePrint = useReactToPrint({
    contentRef,
    // documentTitle: `loadingAdvice_${getLoadingAdvice?.documentNumber || ""}`,
  });

  useEffect(() => {
    setData(tenderData?.data || []);
  }, [tenderData]);

  const loadInitialData = () => {
    setData(tenderData?.data);
  };

  useEffect(() => {
    loadInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenderData]);

  const handlePrintWithData = (row) => {
    setLoadingAdvice(row);

    // Wait for state updates before printing
    setTimeout(() => {
      handlePrint();
    }, 500);
  };
  // eslint-disable-next-line
  const detailTenderNr = (tndNr) => {
    dispatch(tenderNr(tndNr));
    navigate(Constants.PUBLIC_TND_DETAILS);
  };

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [filterShow, setFilterShow] = useState(false);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const tendorColum = [
    {
      name: "Tender Document Nr",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          // onClick={() => detailTenderNr(row.documentNumber)}
        >
          {row.documentNumber}
        </button>
      ),
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Title",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold"> {row.tenderTitle} </span>
        </>
      ),
      selector: (row) => row.tenderTitle,
      sortable: true,
      width: "250px",
    },
    {
      name: "Status",
      selector: (row) => row.tenderHeaderStatus,
      id: "tenderHeaderStatus",
      dropDown: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.tenderHeaderStatus} />
        </>
      ),
      width: "180px",
    },
    {
      name: "Attachments",
      selector: (row) => row.attachments,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center cursor-pointer"
          // onClick={()=>showViewInvoice(row)}
          onClick={() => handlePrintWithData(row)}
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Open Date ",
      selector: (row) => formatDateTime(row.openingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Close Date",
      selector: (row) => formatDateTime(row.closingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Countdown Timer",
      cell: (row) => (
        <>
          <ReverseTimer
            closingDateTime={row.closingDateTime}
            openingDateTime={row.openingDateTime}
          />

          {/* <ReverseTimer closingDateTime={0} openingDateTime={0} /> */}
        </>
      ),
      sortable: true,
      width: "270px",
    },
    {
      name: "Buyer Responsible",
      selector: (row) => row.tenderResponsible,
      sortable: true,
      width: "190px",
    },
    {
      name: "Buyer",
      selector: (row) => row.buyerConact,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.buyerConact} </p>
          <p className="m-0 p-0">{row.buyerEmail} </p>
        </div>
      ),
    },
  ];
  const lineItemColInfo = [
    {
      name: "PR Item Nr",
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">
          {row.purchasingReqDocumentItemNr}{" "}
        </span>
      ),
      width: "180px",
    },
    {
      name: "Material Code",
      cell: (row) => <span>{row.materialCode} </span>,
      width: "180px",
    },
    {
      name: "Material Desc",
      cell: (row) => <span>{row.materialDescription} </span>,
      width: "180px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "180px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "180px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "180px",
    },
    {
      name: "Value",
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.orderPriceUnit).toFixed(2))}
        </span>
      ),
      // cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "180px",
    },
    {
      name: "Curreny",
      cell: (row) => <span>{row.currency} </span>,
      width: "180px",
    },
  ];

  const InvoiceColumns = [
    {
      name: "Invoice No",
      selector: (row) => row.invoiceNr,
      sortable: true,
      width: "140px",
    },
    {
      name: "Generated Date",
      selector: (row) => row.generatedDate,
      sortable: true,
      width: "150px",
    },
    {
      name: "Material Desc",
      selector: (row) => row.materialDescription,
      sortable: true,
      // wrap: true,
      width: "200px",
    },
    {
      name: "Material Code",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Quantity",
      selector: (row) => row.poOrderQuantity,
      sortable: true,
      // right: true,
      width: "130px",
    },
    {
      name: "UOM",
      selector: (row) => row.uOM,
      sortable: true,
      width: "100px",
    },
    {
      name: "TCS Value",
      selector: (row) => row.tcsValue,
      sortable: true,
      // right: true,
      width: "130px",
    },
    {
      name: "Truck No",
      selector: (row) => row.loadingTruckNo,
      sortable: true,
      width: "130px",
    },
    {
      name: "CGST",
      selector: (row) => row.poTotalCgst,
      sortable: true,
      // right: true,
      width: "100px",
    },
    {
      name: "SGST",
      selector: (row) => row.poTotalSgst,
      sortable: true,
      // right: true,
      width: "100px",
    },
    {
      name: "IGST",
      selector: (row) => row.poTotalIgst,
      sortable: true,
      // right: true,
      width: "100px",
    },
    {
      name: "Net Value",
      selector: (row) => row.poTotalAmount,
      sortable: true,
      // right: true,
      width: "130px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row.gstValue,
      sortable: true,
      // right: true,
      width: "120px",
    },
    {
      name: "Gross Value",
      selector: (row) => row.poTotalNetValue,
      sortable: true,
      // right: true,
      width: "140px",
    },
  ];

  const navigateToLogin = () => {
    navigate(Constant.LOGIN);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "TenderDocumentList",
      page: page,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getTenderList(obj));
    setData(tenderData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "TenderDocumentList",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getTenderList(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "TenderDocumentList",
      page: page,
      per_page: newPerPage,
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getTenderList(obj));
    setData(tenderData?.data);
  };
  //on page load
  useEffect(() => {
    let obj = {
      queryName: "TenderDocumentList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getTenderList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getCustomerInvoiceList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    dispatch(getTenderList(obj));
  };

  return (
    <main className="" id="">
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            {/* <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Tender</h2>
                <p className="subText">Lists of Public Tender and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
              <Col xs={4} md={2} lg={2} className="">
                <button
                  className="btnTable"
                  // onClick={() => createRFQ()}
                  // disabled={getApprovedRows.length > 0 ? false : true}
                >
                  <i className="bi bi-plus-lg"></i> Login
                </button>
              </Col>
            </Row> */}
            <Row className="align-items-center">
              <Col xs={12} md={6} lg={6}>
                <h2 className="mainTitle mb-1">Tender</h2>
                <p className="subText mb-0">
                  Lists of Public Tender and details
                </p>
              </Col>

              <Col xs={6} md={3} lg={3} className="pe-2">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>

              <Col xs={3} md={2} lg={2} className="px-1">
                <button className="btnTable w-30" onClick={navigateToLogin}>
                  <i className="bi bi-box-arrow-in-right"></i> Login
                </button>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={tendorColum}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>

                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TL</span>
                    </Col>

                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Tender List</span>
                      <span className="subHeaderTitle">
                        View of Tender and Status{" "}
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={tendorColum}
                          data={data}
                          progressPending={tenderData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={tenderTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <div style={{ display: "none" }}>
          <TendorPrint ref={contentRef} data={getLoadingAdvice} />
        </div>
      </Row>
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <UploadModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        onUploadComplete={handleUploadComplete}
      />
      <UploadDataViewModal
        show={showDataModal}
        onHide={() => setShowDataModal(false)}
        data={parsedData}
        columns={InvoiceColumns}
        title="Uploaded Purchase Data"
        onSave={(data) => {
          // Your API save logic here
          console.log("Save", data);
          setShowDataModal(false);
        }}
      />
    </main>
  );
};

export default PublicTenderList;
